// SEF staff used by the operative activities wizard.
// Admin names are the real SEF admins; the other members are placeholders.
export const sefAdmins = ['Alessio', 'Lorenzo', 'Gian Franco', 'Tiziano']

export const sefTeamMembers = [
  'Operatore 1',
  'Operatore 2',
  'Operatore 3',
  'Operatore 4',
  'Operatore 5',
  'Operatore 6',
]

export const sefStaff = [...sefAdmins, ...sefTeamMembers]
